export var PurposeOfStay = function (PurposeOfStay) {
  PurposeOfStay["LEISURE"] = "LEI";
  PurposeOfStay["BUSINESS"] = "BUS";
  return PurposeOfStay;
}({});